import { forwardRef, lazy, Suspense } from 'react';
import type { PopoverType } from './popover.component';

const PopoverLazy = lazy(() =>
  import('./popover.component').then((m) => ({
    default: m.Popover,
  })),
);

export const Popover = forwardRef<
  { setOpen: (value: boolean) => void },
  PopoverType.Props
>((props, ref) => (
  <Suspense fallback={null}>
    <PopoverLazy {...props} ref={ref} />
  </Suspense>
));

Popover.displayName = 'Popover';

// Export des types
export type { PopoverType } from './popover.component';
export { PopoverContext } from './popover.component';
